<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/94nT6v/tc-custom/9781504083492.jpg?1705346909883" alt="This image is the cover for the book Queen Lucia"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Queen Lucia
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Small-town rivals engage in a ruthless battle of wits in the first novel of this beloved satirical series about the Edwardian upper class.</b></p><p> The small English village of Riseholme may only have one street, but it contains many paths for the committed social climber. In this this eccentric enclave of the idle rich, Emmeline Lucas—known as Lucia—is the reigning social queen. And together with her husband Peppino and her best friend Georgie, she is determined to protect her crown from her neighbor and rival, the fad-chasing Daisy Quantock. </p> But when Daisy discovers the latest sensation—Indian mysticism—Lucia must find a way to capture the interest of a mysterious guru who has all of Riseholme under his spell. As petty gossip turns to vicious scheming, Riseholme will witness a charm offensive like they’ve never seen in this timeless comedy of manners.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        E. F. Benson
      </h2>
      
      <p class="authorDescription body article">Edward Frederic Benson (1867&ndash;1940) was an English novelist, biographer, memoirist, archaeologist, and short story writer. Benson was the son of the Archbishop of Canterbury and member of a distinguished and eccentric family. After attending Marlborough and King&rsquo;s College, Cambridge, where he studied classics and archaeology, he worked at the British School of Archaeology in Athens. A great humorist, he achieved success at an early age with his first novel,&#160;<I>Dodo</I>(1893). Benson was a prolific author, writing over one hundred books including serious novels, ghost stories, plays, and biographies. But he is best remembered for his Lucia and Mapp comedies written between 1920 and 1939 and other comic novels such as&#160;<I>Paying Guests</I>&#160;and&#160;<I>Mrs Ames</I>. Benson served as mayor of Rye, the Sussex town that provided the model for his fictional Tilling, from 1934 to 1937.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?241f23f8